import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataStoreService } from 'src/app/order/store/data-store.service';
import { environment } from 'src/environments/environment.local';

@Injectable({
  providedIn: 'root',
})
export class MccService {
  constructor(private http: HttpClient, private dataStoreService: DataStoreService) {}

  public getMccAbecsByCnpj(cnpj: string, institution: string, serviceContract: number, authorization?: string): Observable<string> {
    const params = new HttpParams()
      .set('institution', institution)
      .set('service-contract', serviceContract?.toString())
      .set('cpfCnpj', cnpj);

    const headerAuthorization = authorization || this.buildAuthorizationHeader();
    let headers = new HttpHeaders();

    if (headerAuthorization) {
      headers = headers.set('Authorization', headerAuthorization);
    }

    return this.http
      .get<number>(`${environment.apiUrls.mcc}/by-cnpj`, { params, headers })
      .pipe(map((res) => (res !== null && res !== undefined ? res.toString() : '')));
  }

  private buildAuthorizationHeader(): string | null {
    const token = this.dataStoreService.getToken();
    if (!token) {
      return null;
    }

    return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
  }
}
